<template>
  <div class="flex flex-1 flex-col bg-orange-light h-min-max">
    <div v-if="customer" class="p-5 z-10">
      <div class="flex flex-row">
        <CustomerOnboardingHeader v-if="customer" class="flex-1 mr-6" :customer="customer" />
        <v-btn variant="flat" rounded="lg" @click="onClose">
          Fermer
        </v-btn>
      </div>
      <div class="relative z-2 flex flex-1 flex-col justify-between">
        <div class="flex flex-row justify-between mt-4 gap-x-8">
          <CustomerOnboardingQrCodeCard
            v-if="customer"
            :downloading="downloading"
            :customer="customer"
            :print="print"
          />
          <div class="flex-1 flex-col">
            <CustomerOnboardingPhoneCard
              :customer="customer"
              :refresh="refresh"
              :downloading="downloading"
              :print="print"
            />
          </div>
        </div>
        <CustomerOnboardingFooter />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {customerCertificationApi} from '@/container';
import CustomerOnboardingHeader from '@/customer-certification/components/CustomerOnboardingHeader.vue';
import CustomerOnboardingPhoneCard
    from '@/customer-certification/components/CustomerOnboardingPhoneCard.vue';
import CustomerOnboardingQrCodeCard
    from '@/customer-certification/components/CustomerOnboardingQrCodeCard.vue';
import CustomerOnboardingFooter from '@/customer-certification/components/CustomerOnboardingFooter.vue';
import printIcon from '@/assets/icons/print.svg';
import Customer, {CustomerCertification} from "@/customer/interfaces/Customer";
import router from "@/router";

export default defineComponent({
    name: 'CustomerCertificationOnboarding',
    components: {
        CustomerOnboardingFooter,
        CustomerOnboardingPhoneCard,
        CustomerOnboardingHeader,
        CustomerOnboardingQrCodeCard,
    },
    emits: ['close', 'certified'],
    setup(props, ctx) {
        const customer: Customer = (ctx.attrs.customer as Customer);

        return {
            customer
        };
    },
    data() {
        return {
            downloading: false,
            printIcon
        };
    },
    methods: {
        /**
         * Print customer certification.
         */
        print(type: string) {
            const customer = this.customer;
            this.downloading = true;

            if (customer?.id) {
                customerCertificationApi().pdfUrl(customer.id, type)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response], {type: response.type}));
                        const printWindow = window.open(url);

                        if (printWindow) {
                            printWindow.onload = () => {
                                try {
                                    printWindow.print();
                                } catch (e) {
                                    console.error('Print failed', e);
                                }
                            };
                        }
                    })
                    .finally(() => {
                        this.downloading = false;
                    });
            }
        },
        /**
         * Refresh customer certification.
         *
         * @param {Object} certification
         */
        refresh(certification: CustomerCertification) {
            this.customer.certification = certification;
            this.$emit('certified', certification);
        },
        /**
         * Action on close.
         */
        onClose() {
            if (router.currentRoute.value.name === 'customer.certification') {
                router.go(-1);
            }
            this.$emit('close');
        }
    }
});
</script>
